import { AfterViewInit, Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { GlobalFunction } from '../core/global_function';
import { API } from '../../config/api';

export class FieldComponent implements OnInit, AfterViewInit {
  @Output()
  onInitValue = new EventEmitter<string>();
  @Output()
  valueChanged = new EventEmitter<string>();
  change_emit($event) {
    this.valueChanged.emit($event);
  }
  _tabindex: any;
  @Input()
  set tabindex(val) { this._tabindex = val; }
  get tabindex() { return this._tabindex; }
  @Input()
  set readonly(value: Observable<any> | any) { this._readonly = value; }
  get readonly() { return this._readonly; }
  @Input()
  set model(value: Observable<any> | any) { this._model = value; }
  get model() { return this._model; }
  @Input()
  set list(value: Observable<any> | any) { this._list = value; }
  get list() { return this._list; }
  @Input()
  set attribute(value: string) { this._attribute = value; }
  get attribute() { return this._attribute; }
  @Input()
  set id(value: string) { this._id = value; }
  get id() {
    if (this._id) { return this._id; }
    if (this._model) {
      this._id = this._model.constructor.name.toLowerCase() + '-' + this.attribute.toLowerCase();
      return this._id;
    }
    return '';
  }
  @Input()
  set options(value: any) { this._options = value; }
  get options() { return this._options; }
  @Input()
  set div_outer(value: boolean) { this._div_outer = value; }
  get div_outer() { return this._div_outer; }
  @Input()
  set inputOptions(value: any) { this._inputOptions = value; }
  get inputOptions() { return this._inputOptions; }
  @Input()
  set errorOptions(value: any) { this._errorOptions = value; }
  get errorOptions() { return this._errorOptions; }
  @Input()
  set labelOptions(value: any) { this._labelOptions = value; }
  get labelOptions() {
    if (!this._labelOptions.for && this._model && this._attribute) {
      this._labelOptions.for = this.id;
    }
    return this._labelOptions;
  }
  _display_label: boolean = true;
  @Input()
  set display_label(value: any) { this._display_label = value; }

  @Input()
  set html_label_require(value: any) { this._html_label_require = value; }
  get html_label_require() {
    return this._html_label_require;
  }
  @Input()
  set labelValue(value: any) {
    this._labelValue = value;
    this.setLabelHtml();
  }
  get labelValue() {
    if (!this._labelValue && this._model && this._model.attributeLabels != undefined && this._model.attributeLabels()[this.attribute]) {
      this._labelValue = this._model.attributeLabels()[this.attribute];
    }
    return this._labelValue;
  }
  @Input()
  set placeHolder(value: any) {
    this._placeholder = value;
  }
  get placeHolder() {
    return this._placeholder;
  }

  _readonly: any = false;
  _list: any;
  _model: any;
  _attribute: string;
  _id: string;
  _options: any = { class: 'item' };
  _div_outer = true;
  _inputOptions: any = { class: 'form-control' };
  _errorOptions: any = { class: 'help-block' };
  _labelOptions: any = { class: 'field' };
  _labelValue: string;
  _errorValue: string;
  _placeholder: string;


  @ViewChild('input') _input: any;
  @ViewChild('label') _label: any;
  @ViewChild('div') _div: any;
  @ViewChild('error') _error: any;
  @ViewChild('hint') _hint: any;
  @ViewChild('require') _require: any;

  constructor() { }

  ngOnInit() { }

  _html_label_require: any = "Required";

  setReadonly() {
    if (this._input) {
      if (this._readonly) {
        this._input.nativeElement.setAttribute('readonly', true);
      } else {
        this._input.nativeElement.removeAttribute('readonly');
      }
    }
  }
  setPlaceHolder() {
    if (this._input) {
      if (this._placeholder) {
        this._input.nativeElement.setAttribute('placeholder', this._placeholder);
      } else {
        this._input.nativeElement.removeAttribute('placeholder');
      }
    }
  }

  setLabelHtml() {
    let rule_attribute = this._model && this._model.rule && this._model.rule()[this.attribute];
    if (this._label) {
      this._label.nativeElement.innerHTML = this.labelValue;
    }
    if (rule_attribute && typeof (rule_attribute) == 'object' && rule_attribute.require && (typeof (rule_attribute.require) != 'object' || rule_attribute.require.empty) && this._label) {
      if (this._require && this._require.nativeElement) {
        this._require.nativeElement.innerHTML = this._html_label_require;
      }
    }
    if (rule_attribute && rule_attribute.require && rule_attribute.require.correlateEmpty && rule_attribute.require.correlateEmpty.isDisplayRequired) {
      if (this._require && this._require.nativeElement) {
        this._require.nativeElement.innerHTML = this._html_label_require;
      }
    }
  }

  ngAfterViewInit() {
    var self = this;
    let rule_attribute = this._model && this._model.rule && this._model.rule()[this.attribute];
    if (this._div) { this.renderOptions(this._div, this.options); }
    if (this._label) {
      this.renderOptions(this._label, this.labelOptions);
      if (typeof (this.labelOptions.html_label_require) != undefined && this.labelOptions.html_label_require) {
        this._html_label_require = this.labelOptions.html_label_require;
      }
      this.setLabelHtml();
    }
    if (this._input) {
      this.setReadonly();
      this.setPlaceHolder();
      this.renderOptions(this._input, this.inputOptions);
      this._input.nativeElement.addEventListener('change', function () { self.model.attr_validate[self.attribute] = true; self.model._attr_submit[self.attribute] = false; this.removeEventListener('change'); });
      this._input.nativeElement.addEventListener('focus', function () { self.model.attr_validate[self.attribute] = true; self.model._attr_submit[self.attribute] = false; this.removeEventListener('focus'); });
      this._input.nativeElement.setAttribute('name', this.attribute);
      this._input.nativeElement.addEventListener('change', function () { self.model._error_api[self.attribute] = undefined; self.model._attr_submit[self.attribute] = false; });
      if (GlobalFunction.contains(this._input.nativeElement.getAttribute('type'), ['text', 'password'])) {
        this._input.nativeElement.addEventListener('keydown', function () { self.model._error_api[self.attribute] = undefined; self.model._attr_submit[self.attribute] = false; self.model.attr_validate[self.attribute] = true; });
      }

      if (rule_attribute && typeof (rule_attribute) == 'object' && rule_attribute.require && typeof (rule_attribute.require) == 'object' && rule_attribute.require.size && rule_attribute.require.size !== undefined) {
        if (typeof (rule_attribute.require.size) == 'object') {
          this._input.nativeElement.setAttribute('maxlength', rule_attribute.require.size.value);
        } else {
          if (rule_attribute.require.size === true) {
            this._input.nativeElement.setAttribute('maxlength', rule_attribute.size);
          } else {
            this._input.nativeElement.setAttribute('maxlength', rule_attribute.require.size);
          }

        }

      }
    }
    if (this._error) { this.renderOptions(this._error, this.errorOptions); }
    if (this._hint) { this.renderOptions(this._hint, this.labelOptions); }
    this.afterInit();
  }

  change_value() {
    this._model.attr_validate[this.attribute] = true;
    this._model._attr_submit[this.attribute] = false;
  }

  afterInit() {

  }
  renderOptions(el, options) {
    if (el && el.nativeElement && options) {
      for (var i in options) {
        el.nativeElement.setAttribute(i, options[i]);
      }
    }
  }

  showError() {
    var m = '';
    if (this.attribute) {
      if (!this._model._error_api) {
        this._model._error_api = {};
      }
      if (this._model._error_api[this.attribute] !== undefined) {
        m = this._model._error_api[this.attribute];
      } else {
        if (!this._model.attr_validate) {
          this._model.attr_validate = {};
        }
        m = this._model.attr_validate[this.attribute] === true ? this._model._validate.error_value(this.attribute) : '';
      }
    }
    return m;
  }

  checkShow() {
    let attr = this._model._validate.rule[this.attribute];
    return attr && attr.display && !this._model._validate.evalCondition(attr.display);
  }
}

@Component({
  selector: 'ftext',
  template: `
        <div [hidden]="checkShow()" #div>
        <label #label></label>
        <input type="text" [(ngModel)]="model[attribute]" #input />
        <p class="form-text text-muted" #require></p>
        <div #error *ngIf="showError()">{{showError()}}</div>
        </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Ftext extends FieldComponent {
}

@Component({
  selector: 'fpassword',
  template: `
    <div [hidden]="checkShow()" #div>
      <label #label></label>
      <input type="password" [(ngModel)]="model[attribute]" #input />
      <p class="form-text text-muted" #require></p>
      <div class="form-text-rq text-muted" *ngIf="_desc && !showError()"> {{_desc}} </div>
      <div #error>{{showError()}}</div>
    </div>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Fpassword extends FieldComponent {
  private _desc: string = null;
  @Input()
  set desc(value) {
    this._desc = value;
  }
  get desc() {
    return this._desc;
  }

}

@Component({
  selector: 'fschooltext',
  template: `
        <div [hidden]="checkShow()" #div>
        <div #label></div>
        <div class="validation-form">
            <input type="text" [disabled]="disabledValue" (keydown)="onDown($event)" autocomplete="off" [(ngModel)]="model[attribute]" #input />
            <div *ngIf="unitValue">{{unitValue}}</div>
            <div class="is-required" #require></div>
            <div #error>{{showError()}}</div>
        </div>
        </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Fschooltext extends FieldComponent {
  @Input()
  set disabled(value: any) { this.disabledValue = value; }
  disabledValue: boolean = false;

  @Input()
  set isAcceptOnlyIntegerNumber(value: any) { this.acceptOnlyIntegerNumber = value; }
  acceptOnlyIntegerNumber: boolean = false;

  @Input()
  set unit(value: any) { this.unitValue = value; }
  unitValue: any;

  onDown(event) {
    if (!this.acceptOnlyIntegerNumber || !event.key || 'Backspace' == event.key) {
      return;
    }
    if (event.key.toString().match('[0-9]') == null) {
      event.preventDefault();
      return;
    }
  }
}

@Component({
  selector: 'fdropdown',
  template: `
    <ng-container>
      <div class="item">
        <div #label></div>
        <div class="validation-form select-form">
          <select name="attribute" [(ngModel)]="model[attribute]" class="form-control select-button" (change)="changeValue($event, model[attribute])">
            <option *ngFor="let item of _listData" [value]="item.value" [disabled]="item.disabled" [selected]="i === 0">{{item.label}}</option>
          </select>
          <div *ngIf="!_desc" class="is-required" #require ></div>
          <div #error>{{showError()}}</div>
          <div *ngIf="outsideValidationValue && !_desc">{{outsideValidationValue}}</div>
          <div class="is-required" id="{{attribute}}" *ngIf="_desc"><span>{{_desc}}</span></div>
        </div>
      </div>
    </ng-container>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Fdropdown extends FieldComponent implements OnInit {
  private _listData: any;
  private _desc: string = null;
  private outsideValidationValue: string = null;
  @Input()
  set listData(value) {
    this._listData = value;
  }
  get listData() {
    return this._listData;
  }


  @Input()
  set outsideValidation(value: any) { this.outsideValidationValue = value; }
  get outsideValidation() { return this.outsideValidationValue; }

  @Input()
  set desc(value) {
    this._desc = value;
  }
  @Input()
  set defaultVal(value) {

    this._listData.forEach(item => {
      if (item.value && value != null && value.toString() == item.value.toString()) {
        this._desc = item.description;
      }
    });
  }
  get desc() {
    return this._desc;
  }

  changeValue(event, value) {
    this._desc = null;
    this.outsideValidation = '';
    this._listData.forEach(item => {
      if (item.value && value != null && value.toString() == item.value.toString() && value == item.value.toString()) {
        this._desc = item.description;
        this.outsideValidation = item.description;
        $('#sub_tier_of_activity').show();
        return;
      }
    });
    this.change_emit(event);
  }
}

@Component({
  selector: 'ftextarea',
  template: `
    <div [hidden]="checkShow()" #div>
        <div  #label></div>
        <div><textarea rows="4" cols="50" class="ftextarea-content" [(ngModel)]="model[attribute]"  #input></textarea></div>
        <div class="is-required" #require></div>
        <div #error>{{showError()}}</div>
    </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Ftextarea extends FieldComponent {
}

@Component({
  selector: 'foneimage',
  template: `
    <div [hidden]="checkShow()" *ngIf="theme == 1" #div>
        <div #label></div>
        <div class="validation-form">
            <oneimage [(ngModel)]="model[attribute]" [show_image]="_show_image" [flag_upload]="_flag_upload" [set_theme]="theme" [set_description]="description" [link]="link" [link_api]="link_api" [attribute_api]="attribute_api" (valueChanged)="change_value2()"></oneimage>
            <div #error>{{showError()}}</div>
        </div>
    </div>
    <div #div *ngIf="theme == 2">
    <oneimage [(ngModel)]="model[attribute]" [flag_upload]="_flag_upload" [set_theme]="theme" [set_description]="description" [link]="link" [link_api]="link_api" [attribute_api]="attribute_api" (valueChanged)="change_value2()"></oneimage>
    </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FOneimage extends FieldComponent {
  _options: any = { class: 'item' };
  _inputOptions: any = { class: '' };
  _labelOptions: any = { class: 'field' };
  _html_label_require: any = "Required";
  theme: number = 1;
  link: string;
  description: string;
  link_api: string;
  attribute_api: {};

  _flag_upload: boolean = true;
  @Input()
  set flag_upload(vl: boolean) {
    this._flag_upload = vl;
  }
  get flag_upload() {
    return this._flag_upload;
  }

  _show_image: boolean = true;
  @Input()
  set show_image(vl: boolean) {
    this._show_image = vl;
  }
  get show_image() {
    return this._show_image;
  }

  @Input()
  set set_theme(vl: any) {
    this.theme = vl;
  }

  @Input()
  set set_description(vl: any) {
    this.description = vl;
  }

  change_value2(event) {
    this.change_value();
    this.change_emit(event);
  }

  afterInit() {
    // var link = CONFIG.LINK_IMAGE + this._model.tableName() + '/';
    // if(this._model.id) {
    //     link += this._model.id + '/';
    // } else {
    // link += 'main/';
    // }
    var that = this;
    setTimeout(function () {
      // that.link = link;
      that.link_api = API.UPLOAD_FILES;
      that.attribute_api = {
        table: that._model.tableName(),
        id: that._model.id,
      };
    }, 1);
  }
}

@Component({
  selector: 'fdate',
  template: `
        <div [hidden]="checkShow()" #div>
        <div #label></div>
        <div class="validation-form">
            <input type="date" [(ngModel)]="model[attribute]" #input />
            <div #error>{{showError()}}</div>
        </div>
        </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FDate extends FieldComponent {
}

@Component({
  selector: 'fdate-input',
  template: `
        <div [hidden]="checkShow()" #div>
        <div #label></div>
        <div class="validation-form">
            <input [(ngModel)]="model[attribute]" [maxlength]="10" (keydown)="onDown($event)" (keyup)="onKey($event)" autocomplete="off" #input />
            <div class="is-required">Date <span class="text-muted">('yyyy-mm-dd')</span></div>
            <div #error>{{showError()}}</div>
        </div>
        </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FDateInput extends FieldComponent {

  onDown(event: any) { // without type info
    if (!event.key) {
      return;
    }
    if ((event.target.value.length != 4 || event.target.value.length != 7)
      && event.key.toString().match('[0-9]') == null && 'Backspace' != event.key) {
      event.preventDefault();
      return;
    }

    if ((event.target.value.length == 4 || event.target.value.length == 7)
      && !event.key.toString().equals('-') && 'Backspace' != event.key) {
      event.preventDefault();
      return;
    }
    if (event.target.value.length == 6 && 'Backspace' != event.key
      && ((parseInt(event.key) > 2 && this.model[this.attribute].endsWith('1')) || event.key.toString() == '0')) {
      event.preventDefault();
      return;
    }

    if (event.target.value.length == 9 && 'Backspace' != event.key) {
      let val = this.model[this.attribute].slice(this.model[this.attribute].length - 1, this.model[this.attribute].length) + event.key;
      if (parseInt(val) > 31) {
        event.preventDefault();
        return;
      }
    }

    if (event.target.value.length == 5 && 'Backspace' != event.key && event.key.toString() != '0' && event.key.toString() != '1' && parseInt(event.key) < 10) {
      this.model[this.attribute] = this.model[this.attribute] + '0' + event.key.toString() + '-';
      event.preventDefault();
      return;
    }

    if (event.target.value.length == 8 && 'Backspace' != event.key && event.key.toString() != '0'
      && event.key.toString() != '1' && event.key.toString() != '2' && event.key.toString() != '3' && parseInt(event.key) < 10) {
      this.model[this.attribute] = this.model[this.attribute] + '0' + event.key.toString();
      event.preventDefault();
      return;
    }

    if ('Backspace' == event.key && event.target.value.endsWith('-')) {
      this.model[this.attribute] = this.model[this.attribute].slice(0, this.model[this.attribute].length - 1);
    }

  }

  onKey(event: any) { // without type info
    if ('Backspace' != event.key) {
      if (event.target.value && event.target.value.length == 4) {
        this.model[this.attribute] = this.model[this.attribute] + '-';
      }
      if (event.target.value && event.target.value.length == 7) {
        this.model[this.attribute] = this.model[this.attribute] + '-';
      }

    }
  }
}

@Component({
  selector: 'ftime',
  template: `
        <div [hidden]="checkShow()" #div>
        <div #label></div>
        <div class="validation-form">
            <input type="time" [(ngModel)]="model[attribute]" #input />
            <div class="is-required">24 hours format</div>
            <div #error>{{showError()}}</div>
        </div>
        </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FTime extends FieldComponent {
}

@Component({
  selector: 'ftime24',
  template: `
        <div [hidden]="checkShow()" #div>
        <div #label></div>
        <div class="validation-form">
            <input [(ngModel)]="model[attribute]" [maxlength]="5" (keydown)="onDown($event)" (keyup)="onKey($event)" autocomplete="off" #input >
            <div class="is-required">24 hours format</div>
            <div #error>{{showError()}}</div>
        </div>
        </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FTime24 extends FieldComponent {
  onDown(event: any) { // without type info
    if (!event.key) {
      return;
    }
    if ('Backspace' == event.key && event.target.value.endsWith(':')) {
      this.model[this.attribute] = this.model[this.attribute].slice(0, this.model[this.attribute].length - 1);
    }

    if ('Backspace' == event.key) {
      return;
    }
    if (event.target.value.length == 0 && event.key.toString().match('[0-2]') == null) {
      event.preventDefault();
      return;
    }
    if (event.target.value.length == 1
      && (("2" != this.model[this.attribute] && event.key.toString().match('[0-9]') == null && event.key.toString() != ':')
        || ("2" == this.model[this.attribute] && event.key.toString().match('[0-3]') == null && event.key.toString() != ':'))) {
      event.preventDefault();
      return;
    }
    if (event.target.value.length == 2 && event.key.toString() != ':' && this.model[this.attribute].indexOf(':') == -1) {
      event.preventDefault();
      return;
    }
    if (event.target.value.length == 3 && event.key.toString().match('[0-5]') == null) {
      event.preventDefault();
      return;
    }
    if (event.target.value.length == 4 && event.key.toString().match('[0-9]') == null) {
      event.preventDefault();
      return;
    }
  }

  onKey(event: any) { // without type info
    if ('Backspace' == event.key) {
      return;
    }
    if (event.target.value && event.target.value.length == 2 && event.target.value.indexOf(':') == -1) {
      this.model[this.attribute] = this.model[this.attribute] + ':';
    }
    if (event.target.value && event.target.value.length == 2 && event.target.value.indexOf(':') > -1) {
      this.model[this.attribute] = "0" + this.model[this.attribute];
    }
    this.calculateTime.emit();
  }
  @Output()
  calculateTime = new EventEmitter<string>();
}

@Component({
  selector: 'fonefile',
  template: `
    <div [hidden]="checkShow()"#div>
        <div #label></div>
        <div class="validation-form">
        <onefile [(ngModel)]="model[attribute]" [link_api]="link_api" [document_name]="model['document_name']" [attribute_api]="attribute_api" (valueChanged)="change_value($event)"></onefile>
            <div #error>{{showError()}}</div>
        </div>
    </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})

export class FOnefile extends FieldComponent {
  _options: any = { class: 'item' };
  _inputOptions: any = { class: '' };
  _labelOptions: any = { class: 'field' };
  link: string;
  link_api: string;
  attribute_api: {};
  afterInit() {
    var that = this;
    setTimeout(function () {
      // that.link = link;
      that.link_api = API.UPLOAD_FILES;
      that.attribute_api = {
        table: that._model.tableName(),
        id: that._model.id,
      };
    }, 1);
  }
}

@Component({
  selector: 'fschoollabel',
  template: `
        <div class="block" [hidden]="checkShow()" #div>
            <div #label></div>
            <div class="value">
                {{ model[attribute] }}
            </div>
        </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Fschoollabel extends FieldComponent {
  _options: any = { class: 'block' };
  _inputOptions: any = { class: '' };
  _labelOptions: any = { class: 'title' };
}

@Component({
  selector: 'fmanyimages',
  template: `
    <div [hidden]="checkShow()" #div>
        <div #label></div>
        <div class="validation-form">
            <manyimages [(ngModel)]="model[attribute]" [show_image]="_show_image" [flag_upload]="_flag_upload" [link]="link" [link_api]="link_api" [attribute_api]="attribute_api" (valueChanged)="change_value2()"></manyimages>
            <div #error>{{showError()}}</div>
        </div>
    </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Fmanyimages extends FieldComponent {
  _options: any = { class: 'item' };
  _inputOptions: any = { class: '' };
  _labelOptions: any = { class: 'field' };
  _html_label_require: any = "Required";
  theme: number = 1;
  link: string;
  description: string;
  link_api: string;
  attribute_api: {};

  _flag_upload: boolean = true;
  @Input()
  set flag_upload(vl: boolean) {
    this._flag_upload = vl;
  }
  get flag_upload() {
    return this._flag_upload;
  }

  _show_image: boolean = true;
  @Input()
  set show_image(vl: boolean) {
    this._show_image = vl;
  }
  get show_image() {
    return this._show_image;
  }

  @Input()
  set set_theme(vl: any) {
    this.theme = vl;
  }

  @Input()
  set set_description(vl: any) {
    this.description = vl;
  }

  change_value2(event) {
    this.change_value();
    this.change_emit(event);
  }

  afterInit() {
    var that = this;
    setTimeout(function () {
      // that.link = link;
      that.link_api = API.UPLOAD_FILES;
      that.attribute_api = {
        table: that._model.tableName(),
        id: that._model.id,
      };
    }, 1);
  }
}

@Component({
  selector: 'fcheckbox',
  template: `
    <div [hidden]="checkShow()" #div *ngIf="theme == 1">
        <label class="box">
            <input type="checkbox" [(ngModel)]="model[attribute]" #input />
            <span class="checkmark"></span>
            <div #error>{{showError()}}</div>
        </label>
        <span #label></span>
    </div>
    <div #div *ngIf="theme == 2">
        <div #label></div>
        <label class="box">
            <input type="checkbox" [(ngModel)]="model[attribute]" #input />
            <span class="checkmark"></span>
            <div #error>{{showError()}}</div>
        </label>
    </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Fcheckbox extends FieldComponent {
  _labelOptions: any = { class: 'field' };
  theme: any = 1;
  @Input()
  set set_theme(value) {
    this.theme = value;
  }
  get set_theme() {
    return this.theme;
  }
}

@Component({
  selector: 'flistcheckbox',
  template: `
    <div [hidden]="checkShow()" #div>
        <label class="box">
            <input type="checkbox" [(ngModel)]="model[attribute]" #input />
            <span class="checkmark"></span>
            <div #error>{{showError()}}</div>
        </label>
        <span #label></span>
    </div>
    `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class Flistcheckbox extends FieldComponent {
  _labelOptions: any = { class: 'text' };
}

@Component({
  selector: 'fitext',
  template: `
      <div [hidden]="checkShow()" #div>
      <div class="validation-form">
          <div #label></div>
          <input type="text" [disabled]="disabledValue" (keydown)="onDown($event)" autocomplete="off" [(ngModel)]="model[attribute]" #input />
          <div *ngIf="unitValue">{{unitValue}}</div>
          <div class="is-required" #require></div>
          <div #error>{{showError()}}</div>
      </div>
      </div>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FItext extends FieldComponent {
  @Input()
  set disabled(value: any) { this.disabledValue = value; }
  disabledValue: boolean = false;

  @Input()
  set isAcceptOnlyIntegerNumber(value: any) { this.acceptOnlyIntegerNumber = value; }
  acceptOnlyIntegerNumber: boolean = false;

  @Input()
  set unit(value: any) { this.unitValue = value; }
  unitValue: any;

  onDown(event) {
    if (!this.acceptOnlyIntegerNumber || !event.key || 'Backspace' == event.key) {
      return;
    }
    if (event.key.toString().match('[0-9]') == null) {
      event.preventDefault();
      return;
    }
  }
}

@Component({
  selector: 'fidropdown',
  template: `
  <ng-container>
    <div class="item">
      <div class="validation-form select-form">
        <div #label></div>
        <select name="attribute" [(ngModel)]="model[attribute]" class="form-control select-button" (valueChanged)="change_value2()" (change)="changeValue(model[attribute])">
          <option *ngFor="let item of _listData" [value]="item.value" [disabled]="item.disabled">{{item.label}}</option>
        </select>
        <div *ngIf="!_desc" class="is-required" #require ></div>
        <div #error>{{showError()}}</div>
        <div *ngIf="outsideValidationValue && !_desc">{{outsideValidationValue}}</div>
        <div class="is-required" id="{{attribute}}" *ngIf="_desc"><span>{{_desc}}</span></div>
      </div>
    </div>
  </ng-container>
`,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FIdropdown extends FieldComponent implements OnInit {
  private _listData: any;
  private _desc: string = null;
  private outsideValidationValue: string = null;
  @Input()
  set listData(value) {
    this._listData = value;
  }
  get listData() {
    return this._listData;
  }


  @Input()
  set outsideValidation(value: any) { this.outsideValidationValue = value; }
  get outsideValidation() { return this.outsideValidationValue; }

  @Input()
  set desc(value) {
    this._desc = value;
  }
  @Input()
  set defaultVal(value) {

    this._listData.forEach(item => {
      if (item.value && value != null && value.toString() == item.value.toString()) {
        this._desc = item.description;
      }
    });
  }
  get desc() {
    return this._desc;
  }

  changeValue(value) {
    this._desc = null;
    this.outsideValidation = '';
    this._listData.forEach(item => {
      if (item.value && value != null && value.toString() == item.value.toString() && value == item.value.toString()) {
        this._desc = item.description;
        this.outsideValidation = item.description;
        $('#sub_tier_of_activity').show();
        return;
      }
    });
  }
}

@Component({
  selector: 'fitextarea',
  template: `
  <div [hidden]="checkShow()" #div>
  <div class="validation-form">
      <div  #label></div>
      <textarea rows="4" cols="50" class="ftextarea-content" [(ngModel)]="model[attribute]"  #input></textarea>
      <div class="is-required" #require></div>
      <div #error>{{showError()}}</div>
  </div>
  </div>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FItextarea extends FieldComponent {
}

@Component({
  selector: 'fidate',
  template: `
      <div [hidden]="checkShow()" #div>
      <div class="validation-form">
          <div #label></div>
          <input type="date" [(ngModel)]="model[attribute]" #input />
          <div #error>{{showError()}}</div>
      </div>
      </div>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FieldComponent),
    multi: true
  }]
})
export class FIDate extends FieldComponent {
}


// WEBPACK FOOTER //
// ./src/app/common/fields/fields.ts